import { NotifyHelper } from "../../../helpers/toast";
import { eLopActionTypeDefine } from "../../action-types/category/ILopActionType";
import { generateActionForKey, generateActions } from "../generateActions";

export const lopActions = {
    ...generateActions(eLopActionTypeDefine, "LOP"),
    ...generateActionForKey(eLopActionTypeDefine, "LOP", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eLopActionTypeDefine, "LOP", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eLopActionTypeDefine, "LOP", "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eLopActionTypeDefine, "LOP", "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eLopActionTypeDefine, "LOP", "LOAD_ERROR", (m) => { NotifyHelper.Error(m) }),
};
